import { MegaphoneIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ChangelogFeed } from '@r/components/changelogs/changelog-feed.tsx';

/**
 * Page « Nouveautés programme » de l'espace Mon Compte : flux chronologique des
 * évolutions du programme, avec recherche, filtres et scroll infini.
 */
export const Changelogs = () => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-hidden flex-grow">
      <div className="pl-8 flex flex-col space-y-10 h-full text-foreground">
        <span>
          <div className="flex flex-nowrap items-center mb-3">
            <MegaphoneIcon className="mr-3" />

            <h1 className="flex items-center font-bold text-2xl md:text-3xl lg:text-[2.75rem] lg:leading-[3.5rem]">
              {t('menu.account.program.news')}
            </h1>
          </div>

          <p className="font-light text-muted-foreground">{t('changelog.feed.subtitle')}</p>
        </span>

        <ChangelogFeed />
      </div>
    </div>
  );
};
